import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    createInvoice: {
        method: 'POST',
        url: `${BASE_PATH_API}/residentInvoice`
    },
    createBulkInvoices: {
        method: 'POST',
        url: `${BASE_PATH_API}/residentInvoice/bulk`
    },
    updateInvoice: {
        method: 'PUT',
        url: `${BASE_PATH_API}/residentInvoice`
    },
    downloadTenantInvoice: {
        method: 'POST',
        url: `${BASE_PATH_API}/residentInvoice/download/tenant`
    },
    downloadOwnerInvoice: {
        method: 'POST',
        url: `${BASE_PATH_API}/residentInvoice/download/owner`
    },
    getResidentInvoiceRecipients: {
        method: 'GET',
        url: `${BASE_PATH_API}/residentInvoice/recipients/:unitAgreementId`
    },
    getResidentInvoiceRecipientsByProperty: {
        method: 'GET',
        url: `${BASE_PATH_API}/residentInvoice/recipients/property/:propertyId`
    },
    hasAccessToEZMail: {
        method: 'GET',
        url: `${BASE_PATH_API}/residentInvoice/hasAccessToEZMail`
    },
    hasAccessToEZMailCached: {
        method: 'GET',
        url: `${BASE_PATH_API}/residentInvoice/hasAccessToEZMail`,
        cache: true,
    },
    getSettings: {
        method: 'GET',
        url: `${BASE_PATH_API}/residentInvoice/settings`
    },
    getDefaultSettingsForProperty: {
        method: 'GET',
        url: `${BASE_PATH_API}/residentInvoice/settings/property/:propertyId`
    },
    getMailingLayouts: {
        method: 'GET',
        url: `${BASE_PATH_API}/residentInvoice/mailingLayouts`
    },
    getMailingSenders: {
        method: 'GET',
        url: `${BASE_PATH_API}/residentInvoice/mailingSenders`
    },
    createSettings: {
        method: 'POST',
        url: `${BASE_PATH_API}/residentInvoice/settings`
    },
    updateSettings: {
        method: 'PUT',
        url: `${BASE_PATH_API}/residentInvoice/settings`
    },
    deleteSettings: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/residentInvoice/settings/:id`
    }
};

export function ResidentInvoicesApi() {
    return createActions(actions);
}
